import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import device from '../../constants/device';
import { SEASON_COLOR } from '../../constants/app';

export const MIN_CONTAINER_HEIGHT = 550;

const MapContainerStyles = styled.div`
    position: relative;
    background: ${props => props.bgColor};
    overflow: hidden;
    min-height: ${MIN_CONTAINER_HEIGHT}px;

    @media ${device.mobile} {
        min-height: 50vh;
    }

    &[aria-expanded='true'] {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 54; /* must be larger then the header z-index (and the chat z-index) */
    }
`;

const MapContainer = ({ children, fullscreen, season }) => (
    <MapContainerStyles bgColor={SEASON_COLOR[season]} aria-expanded={fullscreen}>
        {children}
    </MapContainerStyles>
);

MapContainer.propTypes = {
    fullscreen: PropTypes.bool,
    season: PropTypes.oneOf(Object.keys(SEASON_COLOR)).isRequired,
};

export default MapContainer;
